export default {"src":"/_next/static/media/linkedin.6f33b747.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};